<template>
  <div class="modal-container" :id="uniqueID">
    <div class="modal-content section-modal">
        <section class="unpad ">
            <div class="container">
                <div class="row justify-content-center">
                    <div class="col-12">
                        <div class="feature feature-1 text-center">
                            <div class="feature__body boxed boxed--lg boxed--border">
                                <div class="text-block">
                                    <h3>Empty Checklist</h3>
                                    <p>Would you like to delete this empty checklist?</p>
                                </div>
                                <div class="row">
                                  <div class="col-sm-6">
                                    <button type="submit" class="btn btn-success type--uppercase" @click="answer(true)">Yes</button>
                                  </div>
                                  <div class="col-sm-6">
                                    <button type="submit" class="btn type--uppercase" @click="answer(false)">No</button>
                                  </div>
                                </div>
                            </div>
                        </div>
                        <!--end feature-->
                    </div>
                </div>
                <!--end of row-->
            </div>
            <!--end of container-->
        </section>
    </div>
</div>
</template>

<script>
  export default {
    name: 'ModalYesNo',
    props: ['title', 'text', 'uniqueID'],
    data: function(){
        return {
            yes: function(){},
            no: function(){},
        };
    },
    methods:{
      show: function(){
        mr.modals.showModal($('#' + this.uniqueID));
      },
      setYes:function(func){
        this.yes = func;
      },
      setNo:function(func){
        this.no = func;
      },
      answer:function(response){
        if (response) {
          this.yes();
        }
        else{
          this.no();
        }
        mr.modals.closeActiveModal();
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/ModalYesNo.vue